import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getMedicationsTypes = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/medicationstype', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getMedicationType = id => {
  return api.http.get(`/medicationstype/${id}`)
}

export const searchMedicationsTypes = term => {
  return api.http.get('/medicationstype/select_search', {
    params: {
      term
    }
  })
}

export const getSelectMedicationsTypes = (term, callback) => {
  searchMedicationsTypes(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteMedicationType = id => {
  return api.http.delete(`/medicationstype/${id}`)
}

export const restoreMedicationType = id => {
  return api.http.put(`/medicationstype/${id}/restore`)
}

export const editMedicationType = medicationType => {
  return api.http.put(`/medicationstype/${medicationType._id}`, medicationType)
}

export const addMedicationType = medicationType => {
  return api.http.post('/medicationstype', medicationType)
}



// WEBPACK FOOTER //
// ./src/api/medicationsTypes.js